
































import { Vue, Component, Prop } from 'vue-property-decorator'

import Popup from '@/components/popup/popup.vue'
import BytedIconCloseSmall from '@byte-design/vue-icons/icons/CloseSmall'

@Component({
  name: 'PopupWithClose',
  components: {
    Popup,
    BytedIconCloseSmall
  }
})
export default class PopupWithClose extends Vue {
  @Prop({ type: Boolean, default: false })
  readonly value!: boolean
  @Prop({ type: String, default: '80%' }) height!: string
  @Prop({ type: String, default: 'auto' }) minHeight!: string
  @Prop({ type: String, default: '' }) title!: string
  @Prop({ type: String, default: '' }) cancelText!: string
  @Prop({ type: String, default: '' }) clazz: string

  get styleObj(): any {
    const height = this.height
    const minHeight = this.minHeight

    const heightStr = '300px'
    return { height: height || heightStr, minHeight }
  }
}
